const Currency = (number: number) => {
    return number.toLocaleString('et', { style: 'currency', currency: 'eur' });
}
export default Currency;